// extracted by mini-css-extract-plugin
export var quillEditor = "_m4-1";
export var variable = "_m4-0";